import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { ELSButton, ELSIcon } from 'components/common/els';
import { MarAdministerFormField } from './MarAdministerSidebar';
import MarAdministerStep2Item from './MarAdministerStep2Item';
import './mar.administer.confirm.scss';

interface MarAdministerStep2Props {
  formField: MarAdministerFormField[];
  barcodeEnabled?: boolean;
  addMedication?: Function;
  resetMedication?: Function;
  administer?: Function;
  editMedication?: Function;
  onCheckboxMedication: Function;
  onAdministrationTimeChange?: Function;
  onAdministrationTimeBlur?: Function;
  onInitialsChange?: Function;
  onInitialsBlur?: Function;
  onCommentChange?: Function;
  isAuthor?: boolean;
  userRole?: string;
}

const MarAdministerStep2 = ({
  formField,
  addMedication,
  resetMedication,
  administer,
  editMedication,
  onCheckboxMedication,
  onAdministrationTimeChange,
  onAdministrationTimeBlur,
  onInitialsChange,
  onInitialsBlur,
  onCommentChange,
  barcodeEnabled,
  isAuthor,
  userRole
}: MarAdministerStep2Props) => {
  const [showToast, setShowToast] = useState(true);

  const medicationAddedList = formField?.filter((field) => field.addedMedication);
  const isDisableAdminister = medicationAddedList?.length === 0;
  const orderCount = `Order Item${formField.length > 1 ? 's' : ''}`;
  useEffect(() => {
    if (formField?.length === 1) {
      onCheckboxMedication(formField[0]);
    }
  }, [formField.length]);

  return (
    <>
      <div className="step-2__count">{`${formField.length} ${orderCount}`}</div>
      {showToast && barcodeEnabled && (
        <div className="step-2__toast">
          <ELSIcon name="confirmation-outline-circle" size="1x" color="confirm" customClass="passed" />
          <span className="step-2__toast__text">Patient ID and medication barcode(s) scanned successfully.</span>
          <ELSButton type="debuttonize" iconSize="1x" iconName="close" iconPosition="left" onClick={() => setShowToast(false)} />
        </div>
      )}
      <div className="divider" />
      <div className="step-2__content">
        <div className="left-content">
          <div className="left-content__title">{orderCount}</div>
          <div className="left-content__items">
            {formField?.map((field) => (
              <MarAdministerStep2Item
                key={`${field.id}-${field.dosageTimeTable}-${field.dosageTimeSeparate}`}
                isSingle={formField.length === 1}
                formFieldItem={field}
                onCheckboxMedication={onCheckboxMedication}
                onAdministrationTimeChange={onAdministrationTimeChange}
                onAdministrationTimeBlur={onAdministrationTimeBlur}
                onInitialsChange={onInitialsChange}
                onInitialsBlur={onInitialsBlur}
                onCommentChange={onCommentChange}
                addMedication={addMedication}
                editMedication={editMedication}
                resetMedication={resetMedication}
                isAuthor={isAuthor}
              />
            ))}
          </div>
        </div>
        <div className="divider-vertical" />
        <div className="right-content">
          <div className="right-content__details">
            <div className="right-content__details__title">Order Administration Details</div>
            <div className="right-content__details__item">
              <p>{orderCount}</p>
              <p>Status</p>
            </div>
            {!medicationAddedList?.length && (
              <div className="right-content__details__item">
                <p>No orders added to cart</p>
              </div>
            )}
            {!!medicationAddedList?.length &&
              medicationAddedList.map((item) => (
                <div className="right-content__details__item" key={`${item.id}-${item.dosageTimeTable}-${item.dosageTimeSeparate}`}>
                  <p>{item.drugName}</p>
                  <p>Complete</p>
                </div>
              ))}

            <p className="right-content__details__total">{`Total: ${medicationAddedList.length}`}</p>
          </div>
          {(userRole === 'Stu' || isAuthor) && (
            <div className="right-content__action">
              <ELSButton text="Administer" onClick={administer} isDisabled={isDisableAdminister} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  userRole: appSelectors.getUserRole(state)
});

export default connect(mapStateToProps)(MarAdministerStep2);
